<template v-if="addValueRestrictionMenu.isVisible">
    <SwipeModalComponent v-if="addValueRestrictionMenu.isVisible" @closeMenu="changeAddValueRestrictionMenuVisibility">
        <div class="content-wrapper">
            <h2>Adicionar Limite de Consumo</h2>

            <div class="store">
                <h2>Loja</h2>
                <select class="select" v-model="selectedStore">
                    <option value="" disabled selected hidden>Selecione uma escola</option>
                    <option class="option"
                        v-for="(store, key) in unrestrictedFamilies"
                        :key="key"
                        :value="store.CDFAMILISALD"
                        v-text="store.NMFAMILISALD"
                    ></option>
                </select>
            </div>

            <div class="daily-limit">
                <text>Limite diário</text>
                <input type="text" placeholder="R$ 0,00" maxlength="12" v-model="formattedLimit" @input="formatValue" />
            </div>

            <div class="confirmButton" @click="addRestriction">
                <button>Confirmar</button>
            </div>
        </div>
    </SwipeModalComponent>

</template>
<script >
import SwipeModalComponent from './SwipeModalComponent.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'AddValueRestrictionComponent',
    props: ['unrestrictedFamilies'],
    emits: ['addRestriction'],
    components: {
        SwipeModalComponent
    },
    data () {
        return {
            limit: 0,
            formattedLimit: 'R$ 0,00',
            selectedStore: ''
        }
    },
    computed: {
        ...mapGetters(['addValueRestrictionMenu'])
    },
    methods: {
        ...mapActions(['changeAddValueRestrictionMenuVisibility']),
        addRestriction: function () {
            if (this.selectedStore === '') {
                alert('Selecione uma escola e um produto')
                return
            }
            this.$emit('addRestriction',
                this.selectedStore,
                this.limit
            )

            this.changeAddValueRestrictionMenuVisibility()
            this.resetData()
        },
        formatValue: function (event) {
            const value = event.target.value.replace(/\D/g, '')
            const formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100)
            this.formattedLimit = formattedValue
            this.limit = value / 100
        },
        resetData: function () {
            this.selectedStore = ''
            this.limit = 0
            this.formattedLimit = 'R$ 0,00'
        }
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;
    .stripe {
        position: relative;
        display: block;
        width: 35px;
        height: 4px;
        background: #B4B4B4;
        border-radius: 30px;
        margin: 30px auto 25px auto;
    }
    h2 {
        text-align: center;
        &:last-of-type {
            margin-bottom: 40px;
        }
    }

    .store {
        margin-bottom: 30px;
        h2 {
            margin-bottom: 10px;
            text-align: left;
        }
        .select {
            width: 100%;
            height: 30px;
            border: solid #BAB8B8 2px;
            border-radius: 5px;
            padding: 0 10px;
            font-size: 18px;
            font-family: Gellix;
            &:focus {
                outline: none;
            }

            option {
                font-size: 14px;
            }
        }
    }

    .daily-limit {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
        padding-top: 20px;
        border-top: solid #BAB8B8 2px;

        input {
            width: 40%;
            border: 1px solid #B4B4B4;
            border-radius: 5px;
            padding: 10px 0;
            text-align: center;
            margin-top: 10px;
        }
    }

    .confirmButton {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 20px;
    }

    button {
        text-align: right;
        border-radius: 5px;
        color: var(--buttonText);
        padding: 10px;
        margin: 0;
        font-weight: 600;
        border: none;
        background-color: var(--buttonBackground);
    }
}
</style>
